import React, { Fragment } from "react"
import propTypes from "prop-types";

import { getToolBoxIconByRef, getToolBoxItemByRef } from "../toolbox/ToolBoxItems";
import { FiCheck, FiPlay } from "react-icons/fi";
import { Workflow, IWorkflowToolBoxItem, WorkflowAction } from "../../../../logic/api";
import { useTranslation } from "react-i18next";

const FlowRender: React.FunctionComponent<{
    flow: Workflow;
    isProcessView: boolean;
    selectedId: string | null;
    toolBoxItems: IWorkflowToolBoxItem[];
    completed?: string[];
    onActionSelected: (action: WorkflowAction | null) => void
}> = (props) => {


    const completed = props.completed == null ? [] : props.completed;
    const startSelected = props.selectedId == null;
    const { t } = useTranslation();

    return <div style={{ padding: 25 }}>
        {
            props.isProcessView == false && (
                <Fragment>
                    {props.flow.name != null && (<h1 style={{ color: "gray", fontWeight: "normal" }}>
                        {t("workflow.workflowBuilder", { code: props.flow.productCode })}
                    </h1>)}

                    {props.flow.version != null && (<h3 style={{ color: "gray", fontWeight: "normal" }}>
                        {t("workflow.version", { version: props.flow.version })}
                    </h3>)}
                </Fragment>
            )
        }
        {
            props.isProcessView == false && (
                <div style={{
                    width: 100,
                    height: 100,
                    display: "inline-block",
                    marginLeft: 50,
                    position: "relative",

                }}>
                    <div
                        onClick={() => {
                            props.onActionSelected(null);
                        }}
                        style={{
                            textAlign: "center",
                            backgroundColor: "#eee",
                            border: startSelected ? "solid 3px orange" : "solid 3px #eee",
                            cursor: "pointer",
                            borderRadius: 100,
                            width: 100,
                            height: 100,
                            opacity: 1

                        }}>
                        <div style={{ paddingTop: 20 }}>
                            <FiPlay size={30} color={startSelected ? "orange" : "black"}></FiPlay>
                        </div>
                        <div style={{ paddingTop: 10, color: startSelected ? "orange" : "black" }}>
                            <strong>{t("workflow.start")}</strong>
                        </div>
                    </div>
                </div>
            )
        }
        {props.flow.actions.map((action, index) => {
            const toolBoxItem = getToolBoxItemByRef(props.toolBoxItems, action.toolRef);


            if (toolBoxItem == null) {
                return <Fragment key={index}></Fragment>
            }
            if (toolBoxItem.visibleAsProcess == false && props.isProcessView == true) {
                return <Fragment key={index}></Fragment>
            }
            const selected = props.selectedId == action.id;

            const complete = completed.indexOf(action.id) != -1;

            const icon = getToolBoxIconByRef(props.toolBoxItems, action.toolRef, 30, selected ? "orange" : "black");

            return <Fragment key={index}>

                <div style={{
                    width: 100,
                    height: 100,
                    display: "inline-block",
                    marginLeft: 50,
                    position: "relative",
                }}>

                    <div
                        onClick={() => {
                            props.onActionSelected(action);
                        }}
                        style={{
                            textAlign: "center",
                            backgroundColor: "#eee",
                            border: selected ? "solid 3px orange" : "solid 3px #eee",
                            cursor: "pointer",
                            borderRadius: 10,
                            width: 100,
                            height: 100,
                            opacity: complete == true ? 0.5 : 1

                        }}>
                        <div style={{ paddingTop: 20 }}>
                            {icon}
                        </div>
                        <div style={{ paddingTop: 10, color: selected ? "orange" : "black" }}>
                            <b>{toolBoxItem.name}</b>
                        </div>
                    </div>
                    {complete == true && (
                        <div style={{ position: "absolute", right: -10, top: -10 }}>
                            <FiCheck color="green" size={30}></FiCheck>
                        </div>
                    )}
                    <div style={{ position: "absolute", left: -46, width: 46, top: "50%", height: 5, borderTop: "dotted 2px gray" }}></div>

                </div>
            </Fragment>
        })}
        <div style={{ width: 50, height: 100, display: "inline-block", }}></div>
    </div>
}

FlowRender.propTypes = {
    flow: propTypes.any.isRequired,
    onActionSelected: propTypes.func.isRequired,
    toolBoxItems: propTypes.any.isRequired,
    selectedId: propTypes.any,
    completed: propTypes.any,
    isProcessView: propTypes.bool.isRequired
}

export default FlowRender;